import styled from 'styled-components';

import { sizeUp } from '~/theme';
import PlainCard from '~atoms/PlainCard';

const paddingInline = '20rem';

const minDesktopWidth = '1081rem';

export const Container = styled(PlainCard)(({ theme }) => ({
  height: '504rem',
  maxWidth: sizeUp('300rem', [minDesktopWidth, '437rem']),

  fontFamily: theme.typography.family.arial,
}));

export const Content = styled.article({
  overflow: 'hidden',
  borderRadius: 'inherit',
  height: '100%',
});

export const Figure = styled.figure(({ theme }) => ({
  margin: 0,

  img: {
    objectFit: 'cover',

    width: `calc(100% - ${paddingInline})`,
    height: '200rem',
    borderRadius: '15rem',
    padding: '10rem',
  },

  figcaption: {
    paddingInline,

    fontFamily: theme.typography.family.playfairDisplay,
    fontSize: '20rem',
    letterSpacing: '1rem',
    textTransform: 'uppercase',
  },
}));

export const PriceRange = styled.p(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',

  paddingInline,
  marginBlockStart: '10rem',
  marginBlockEnd: '20rem',

  fontSize: theme.typography.size14,
}));

export const SpecificationsList = styled.ul(({ theme }) => ({
  listStyleType: 'none',

  display: 'flex',
  flexDirection: 'column',
  gap: '16rem',

  margin: 0,
  paddingBlock: 0,
  paddingInline,

  '&::before': {
    content: 'attr(aria-label)',

    fontSize: theme.typography.size14,
    fontWeight: 'bold',
    textTransform: 'uppercase',
    letterSpacing: '.5rem',
  },
}));
